import { HttpInterceptorFn } from '@angular/common/http';
export const authInterceptor: HttpInterceptorFn=(request,next)=>{
  const token=typeof localStorage==='undefined'?null:localStorage.getItem('agbe-admin-token');
  return next(token?request.clone({setHeaders:{Authorization:`Bearer ${token}`}}):request);
};
